import AssignablePropertiesFields from './AssignablePropertiesFields'
import type { SquadOption } from './AssignablePropertiesFields'
import type { AssignableFields } from './AssignablePropertiesFields'
import { SliderField, TeamField } from './editorUi'
import { fobOf, isTeamMarker, markerDefaultColor, teamOf, teamSrc } from './markers'
import { useLanguage } from '@/contexts/LanguageContext'

interface MarkerMember {
  id: string
  name: string
  avatar_url: string
}

export interface PlacedMarkerData {
  id: string
  src: string
  worldX: number
  worldY: number
  color: string
  title: string
  text: string
  squads: { id?: string; name: string; color: string }[]
  members: MarkerMember[]
  /** Yalnızca FOB'da anlamlı: alanın dönüşü, derece (0 = kuzeye bakar). */
  rotation?: number
}

interface Props {
  marker: PlacedMarkerData
  onUpdate: (updated: PlacedMarkerData) => void
  squadPresets?: SquadOption[]
}

export default function MarkerPropertiesPanel({ marker, onUpdate, squadPresets }: Props) {
  const { T } = useLanguage()
  const isFob = !!fobOf(marker.src)
  const fields: AssignableFields = {
    title: marker.title,
    text: marker.text,
    color: marker.color,
    squads: marker.squads,
    members: marker.members,
  }

  return (
    <div className="flex-1 overflow-y-auto p-3 space-y-4">
      {isTeamMarker(marker.src) && (
        <TeamField
          label={T.strategy.team}
          noneLabel={T.strategy.teamNone}
          value={teamOf(marker.src)}
          onChange={team => {
            const src = teamSrc(marker.src, team)
            onUpdate({ ...marker, src, color: markerDefaultColor(src) })
          }}
        />
      )}
      {/* FOB alanının yönü — haritadaki tutamaçla da döner; burası kesin açı için. */}
      {isFob && (
        <SliderField
          label={T.strategy.fobRotation}
          display={`${Math.round(marker.rotation ?? 0)}°`}
          value={Math.round(marker.rotation ?? 0)}
          min={0} max={359}
          onChange={v => onUpdate({ ...marker, rotation: v })}
        />
      )}
      <AssignablePropertiesFields
        fields={fields}
        squadPresets={squadPresets}
        onFieldsChange={patch => onUpdate({ ...marker, ...patch })}
      />
    </div>
  )
}
